import { useTranslation } from "react-i18next";
import image from '../../img/PremiumService/overview.png';
import Button from "../Button";

const Overview = () => {
    const { t } = useTranslation();
    return (
        <section className="open-sans relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto sm:mx-[20px] relative">
                <div className="bg-[#fff] sm:rounded-[20px] relative overflow-hidden xl:px-[70px] px-[20px] md:pt-[55px] md:pb-[55px] py-[40px] pb-0">
                    <div className="relative z-10 text-center xl:w-[519px] lg:w-[500px] md:w-[340px] ml-[auto]">
                        <h2 className="text-[#0C2780] font-[700] text-[28px] xl:text-[45px]">
                            {t('premium.overview.title')}
                        </h2>
                        <p className="mt-[15px] sm:text-[16px] text-[14px] text-[#0C2780] font-[300]">
                            {t('premium.overview.text')}
                        </p>
                        <p className="mt-[13px] md:mt-[15px] sm:text-[16px] text-[14px] text-[#0C2780] font-[600]">
                            {t('premium.overview.subtitle')}
                        </p>
                        <div className="flex justify-center">
                            <Button className="mt-[40px] hidden md:flex" color="#15318D" text="#EFEFEF" />
                        </div>
                    </div>
                    <img className="md:absolute relative z-0 xl:w-[542px] md:w-[400px] sm:w-full sm:max-w-[400px] w-[calc(100%)+40px] ml-[-20px] md:max-w-[unset] bottom-0 md:left-[0px] flex sm:mx-auto mt-[30px] md:mt-0" src={image} alt='' />
                </div>
            </div>
        </section>
    )
};

export default Overview;
